import type { Circuit, PlayerTrackPosition } from '../types/track.js';
import { trackPositionGridKey } from './trackMovement.js';
import { normalizeMainPathIndex } from './jokerLap.js';

/** Circuit dont la première et la dernière case du path partagent les mêmes coordonnées (boucle S/F). */
export function hasStartFinishCellOverlap(circuit: Circuit): boolean {
  const pathLen = circuit.path.length;
  if (pathLen < 2) return false;
  const start = circuit.path[0];
  const end = circuit.path[pathLen - 1];
  return start.x === end.x && start.y === end.y;
}

/**
 * Pilote à l’index 0 sur la même case qu’un rival à pathLen-1 (côté « départ » de la boucle S/F).
 */
export function isStartSideOnSfOverlap(
  circuit: Circuit,
  playerIndex: number,
  position: PlayerTrackPosition,
  lapCount: number,
  getPosition: (playerIndex: number) => PlayerTrackPosition,
  getLapCount: (playerIndex: number) => number,
  playerIndices: readonly number[]
): boolean {
  if (!hasStartFinishCellOverlap(circuit)) return false;
  const pathLen = circuit.path.length;
  const idx = normalizeMainPathIndex(position.mainPathIndex, pathLen);
  if (idx !== 0 || lapCount !== 0) return false;
  if (position.jokerBranchIndex != null || position.startLaneIndex != null) return false;
  const key = trackPositionGridKey(circuit, position);
  if (!key) return false;
  for (const other of playerIndices) {
    if (other === playerIndex) continue;
    const op = getPosition(other);
    if (op.jokerBranchIndex != null || op.startLaneIndex != null) continue;
    const oidx = normalizeMainPathIndex(op.mainPathIndex, pathLen);
    if (oidx !== pathLen - 1 || getLapCount(other) !== lapCount) continue;
    const ok = trackPositionGridKey(circuit, op);
    if (ok === key) return true;
  }
  return false;
}
